import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "levels",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "levels" */ "./components"),
      import(/* webpackChunkName: "levels" */ "./modules/LevelsModule"),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      injectReducer(store, {
        key: "levels",
        reducer,
      });

      return component;
    })
  ),
});
